// slider.js — Apple-style auto-advancing category slider
(function () {
  "use strict";
  function setup(root) {
    var track = root.querySelector("[data-track]");
    var slides = [].slice.call(root.querySelectorAll(".cs-slide"));
    var dotsHost = root.querySelector("[data-dots]");
    var prev = root.querySelector("[data-prev]");
    var next = root.querySelector("[data-next]");
    if (!track || !slides.length) return;

    var i = 0, timer = null;
    var DURATION = 5000;
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    // build dots
    var dots = [];
    if (dotsHost) {
      dotsHost.innerHTML = "";
      slides.forEach(function (_, idx) {
        var d = document.createElement("button");
        d.className = "cs-dot";
        d.type = "button";
        d.setAttribute("aria-label", "Ir a la diapositiva " + (idx + 1));
        d.addEventListener("click", function () { go(idx, true); });
        dotsHost.appendChild(d);
        dots.push(d);
      });
    }

    function render() {
      track.style.transform = "translateX(" + (-i * 100) + "%)";
      slides.forEach(function (s, idx) { s.classList.toggle("is-active", idx === i); });
      dots.forEach(function (d, idx) { d.classList.toggle("is-active", idx === i); });
    }
    function go(n, user) {
      i = (n + slides.length) % slides.length;
      render();
      if (user) restart();
    }
    function start() {
      if (reduce) return;
      stop();
      timer = setInterval(function () { go(i + 1); }, DURATION);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }

    if (next) next.addEventListener("click", function () { go(i + 1, true); });
    if (prev) prev.addEventListener("click", function () { go(i - 1, true); });

    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", start);

    // basic swipe
    var x0 = null;
    root.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener("touchend", function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1), true);
      x0 = null;
    }, { passive: true });

    render();
    start();
  }

  function init() {
    [].slice.call(document.querySelectorAll("[data-slider]")).forEach(setup);
  }
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", init);
  else init();
})();
